import styled from 'styled-components';

export default function DiscountAmountInput(props) {
  const { value, setValue, placeholder, width, height, disabled, isBgColor, textAlign = 'right', isFlex = false } = props;

  function onChangeInput(e) {
    setValue(e.target.value);
  }

  return (
    <InputView width={width} height={height} disabled={disabled} $isBgColor={isBgColor} $textAlign={textAlign} isFlex={isFlex}>
      <Input
        type='text'
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        $textAlign={textAlign}
        onChange={onChangeInput} />
    </InputView>
  );
}

const InputView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: ${props => props.$textAlign === 'left' ? 'flex-start' : 'flex-end'};
  align-items: center;

  padding: 0 8px;

  width: ${props => props.width ? `${props.width}px` : props.isFlex ? undefined : '100%'};
  flex: ${props => props.isFlex ? 1 : undefined};
  height: ${props => props.height ? `${props.height}px` : '30px'};

  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;
  background-color: ${props => props.$isBgColor ? props.theme.background : props.theme.subBackground};

  &:focus-within {
    border-color: ${props => props.theme.subKey};
  }

  transition: border-color 0.3s ease-in-out;
`;

const Input = styled.input`
  width: 100%;
  height: 21px;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  text-align: ${props => props.$textAlign};

  color: ${props => props.theme.subKey};
  background: transparent;

  border: none;
  outline: none;
  padding: 0;

  &::placeholder {
    color: ${props => props.theme.subText};
  }
`;
